import { render, staticRenderFns } from "./OthersTab.vue?vue&type=template&id=2abf51b4"
import script from "./OthersTab.vue?vue&type=script&lang=js"
export * from "./OthersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports